import { IViewItemAnalytics } from './types';
import addToCartAnalyticsBuilder from './addToCartAnalyticsBuilder';
import AnalyticsService from './AnalyticsService';

interface AddToCartSelection {
  price: number;
  quantity: number;
  itemVariant: string;
}

export default function fireAddToCartAnalytics(
  viewItemAnalytics: IViewItemAnalytics | undefined,
  selections: AddToCartSelection[],
): void {
  if (!viewItemAnalytics || !selections?.length) return;

  const addToCartData = addToCartAnalyticsBuilder.buildMultipleItems(viewItemAnalytics, selections);

  if (addToCartData) {
    AnalyticsService.trackAddToCart(addToCartData);
  }
}
